import { Link } from 'react-router-dom';
import { useDict } from '../i18n/dictionary';
import { shell } from '../i18n/shell';
import { useAuth } from '../lib/auth';

/**
 * The one screen for a URL no route matches. Signed out it is the message and
 * nothing else — no way in, no app names — so it tells a stranger nothing
 * about what sits behind the login.
 */
export function NotFound() {
  const t = useDict(shell);
  const { status } = useAuth();
  const signedIn = status === 'authenticated';

  return (
    <div className={signedIn ? 'not-found' : 'not-found is-standalone'}>
      <div className="not-found-content">
        <h1 className="not-found-title">{t.notFoundTitle}</h1>
        <p className="not-found-body">{t.notFoundBody}</p>
        {signedIn && (
          <Link to="/apps" className="btn-primary not-found-action">
            {t.backToApps}
          </Link>
        )}
      </div>
    </div>
  );
}
